(function() {
    'use strict';

    class UnsubscribeService {
        constructor($http, ICM_UNSUBSCRIBE_API, $q) {
            this.$http = $http;
            this.icmUnsubscribeApi = ICM_UNSUBSCRIBE_API;
            this.$q = $q;
        }

        getDistributionUnsubscribes(distributionId) {
            let unsubsDistUrl = `${this.icmUnsubscribeApi}/unsubscribes/`,
                httpOptions = {
                    distributionId: distributionId
                };

            return this.$http.post(unsubsDistUrl, httpOptions).then((response) => {
                if (response && response.data) {
                    return {
                        unsubscribes: response.data
                    };
                }
            });
        }

        getDistributionUnsubscribeTotal(distributionId) {
            let unsubsDistUrl = `${this.icmUnsubscribeApi}/unsubscribes/count`,
                httpOptions = {
                    distributionId: distributionId
                };

            return this.$http.post(unsubsDistUrl, httpOptions).then((response) => {
                if (response && response.data) {
                    return response.data;
                }
                return 0;
            });
        }

        didEmailUnsubscribeFromICM(emailAddress) {
            let unsubsDistUrl = `${this.icmUnsubscribeApi}/unsubscribes/`,
                didUnsubscribe = false,
                httpOptions = {
                    type: 'unsubscribe',
                    recipientEmails: [emailAddress]
                };

            return this.$http.post(unsubsDistUrl, httpOptions).then((response) => {
                if (response && response.data) {
                    if(response && response.data && Array.isArray(response.data) && (response.data.length > 0)) {
                        didUnsubscribe = true;
                    }
                    return didUnsubscribe;
                }
            });
        }

        unsubscribedContactStatus(contactsEmailArray) {
            for(var i = 0; i < contactsEmailArray.length; i++){
                contactsEmailArray[i] = contactsEmailArray[i].trim().toLowerCase();
            }

            let defer = this.$q.defer(),
                unsubsDistUrl = `${this.icmUnsubscribeApi}/validate/unsubscribe/subscription/statuses`,
                httpOptions = {
                    recipientEmails: contactsEmailArray
                };

            this.$http.post(unsubsDistUrl, httpOptions).then(function(response) {
                defer.resolve({to: response.data});
            }).catch(function(error) {
                defer.reject(error);
            });

            return defer.promise;
        }

    }

    angular
        .module('MW.Influencers.IcmUnsubscribeService', [
            'Configuration'
        ])
        .service('IcmUnsubscribeService', [
            '$http',
            'ICM_UNSUBSCRIBE_API',
            '$q',
            UnsubscribeService
        ]);
})();
